import { generateConfidenceColors } from "./generateConfidenceColors.js";

// Autumn Day theme - light warm palette
// Inspired by warm fall afternoons with golden sunlight
// Features peachy backgrounds, burnt oranges, and forest greens

const primary = "66.5% 0.127 64.144";  // burnt orange #c98133
const content = "30.4% 0.067 135.273"; // forest green (dark text) #1f3611

export const autumnDayTheme = {
  name: "autumn-day",
  default: false,
  prefersDark: false,
  colorScheme: "light",
  colors: {
    // Base colors - warm peach backgrounds
    "base-100": "92.2% 0.041 62.536",    // lightest cream #fae0ca
    "base-200": "92.5% 0.024 59.379",    // pale peachy #f3e3d7
    "base-300": "87.5% 0.008 332.136",   // soft gray-lavender #d9d4d8
    "base-content": "30.4% 0.067 135.273", // dark forest green #1f3611

    // Primary colors - burnt orange
    "primary": "66.5% 0.127 64.144",       // burnt orange #c98133
    "primary-content": "92.2% 0.041 62.536", // cream for contrast

    // Secondary colors - dusty rose (darkened for legible text on light bg)
    "secondary": "54.0% 0.105 20.000",   // dusty rose #a8534a
    "secondary-content": "92.2% 0.041 62.536", // cream for contrast

    // Accent colors - rich burgundy
    "accent": "51.4% 0.188 21.135",      // rich burgundy #bb2034
    "accent-content": "92.2% 0.041 62.536", // cream for contrast

    // Neutral colors
    "neutral": "63.0% 0.063 98.241",     // olive-brown #938a5d
    "neutral-content": "30.4% 0.067 135.273", // dark green

    // Semantic colors
    "info": "68.7% 0.041 121.969",        // sage green #969f83
    "info-content": "23.7% 0.059 132.799", // very dark green for contrast

    "success": "40.4% 0.042 117.153",     // dark olive green #474c32
    "success-content": "92.2% 0.041 62.536", // cream for contrast

    "warning": "64.7% 0.153 58.199",      // bright orange #d17204
    "warning-content": "23.7% 0.059 132.799", // very dark green for contrast

    "error": "38.3% 0.132 19.344",         // deep burgundy #7a1825
    "error-content": "92.2% 0.041 62.536", // cream for contrast

    // Confidence levels for Tamil learning
    ...generateConfidenceColors(primary, content, false)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.5rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "1",
    "noise": "0"
  }
};
